// src/pages/notfound/NotFound.js
import React from 'react';
import { Link } from 'react-router-dom';
import './notFound.css'; // Si vous voulez ajouter du style

const NotFound = () => {
  return (
    <div className="not-found-container">
      <h1>404 - Page non trouvée</h1>
      <p>Désolé, la page que vous recherchez n'existe pas.</p>
      <Link to="/" className="home-link">
        Retour à l'accueil
      </Link>
    </div>
  );
};

export default NotFound;